import React, { useEffect, useState } from "react";
import EmployeeHeader from "./components/EmpolyeeHeader";
import EmployeeTable from "./components/EmployeeTable";
import { getEmployees } from "./services/employeeservice";

const Employee = () => {
  const [employees, setEmployees] = useState([]);

  useEffect(() => {
    const fetchEmployees = async () => {
      try {
        const data = await getEmployees();

        console.log("API Response:", data);

        setEmployees(data.data || []);
      } catch (error) {
        console.error("Error fetching employees:", error);
      }
    };

    fetchEmployees();
  }, []);

  return (
    <div className="w-full min-h-screen bg-slate-50">
      <EmployeeHeader />
      <EmployeeTable employees={employees} />
    </div>
  );
};

export default Employee;